// JavaScript source code
import React, { useState, useEffect, useRef} from 'react';
import { useParams, Link, useNavigate, json } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import ConfirmDialog from '../components/confirmDialog';
import { get, getUser, handleImageError, getCart, saveCart } from '../request';
import Button from '../components/button';
import dataFoot from '../assets/fake-data/data-foot';
import CheckBox from '../components/checkbox';
import config from '../config';
function Cartlist(props) {
    const activeIndex = 5;

    const [errorMessage, setErrorMessage] = useState("");
    var parentBusinessId = 0;    
    const navigate  = useNavigate ();
    const [isShowLogin, setIsShowLogin] = useState(false);   
    const [isLoading, setShowLoading] = useState(false);
    const [isShowConfirmDialog, setConfirmDialog] = useState(false);

    var user = getUser();
    const [currentDId, setCurrentDId] = useState(0);
    const [selectedAll, setSelectedAll] = useState(true);
    const [item, setItem] = useState([]);
    const [cartlist, setCartlist] = useState([]);
    const [cartlistsub, setCartlistsub] = useState([]);   
    const [currentItem, setCurrentItem] =useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [totleprice, setTotleprice] = useState(0);
    //const [totlepriceTz, setTotlepriceTz] = useState(0);
    const [totlepoint, setTotlepoint] = useState(0);
    //const [totalPriceOriginal, setTotalPriceOriginal] = useState(0);
    //const [totalPriceOriginalDK, setTotalPriceOriginalDK] = useState(0);
    //const [totalPriceOriginalYDK, setTotalPriceOriginalYDK] = useState(0);

    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        refreshCartlistsub();
    }, [cartlistsub]);
    useEffect(() => {       
        loadData();
    }, []);
    
    const refreshCartlistsub = () => {
        if (cartlistsub) {
            var totleprice = 0;
            var totlepoint = 0;
            var originalTotalPrice = 0;
            var originalTotalPriceYDK = 0;
            setSelectedAll( true);
            var buyItems = {
                skus: [],
                price: 0
            };

            var theSelectedItems = cartlistsub.filter(function (cart) {
                if (cart.selected) {
                    if (cart.sku.isCanPoints) {
                        totlepoint = totlepoint + cart.pointsDeduction;
                        if (cart.pointsDeductionInput) {
                            totlepoint = totlepoint - parseFloat(cart.pointsDeductionInput);
                            totleprice = totleprice + parseFloat(cart.pointsDeductionInput);
                        }
                    } else {
                        totleprice = totleprice + cart.sum * cart.sku.servicePrice;
                        if (cart.pointsDeductionInput) {
                            totlepoint = totlepoint + parseFloat(cart.pointsDeductionInput);
                            totleprice = totleprice - parseFloat(cart.pointsDeductionInput);
                        }
                    }

                    if (!cart.sku.isCanPoints) {
                        originalTotalPrice = originalTotalPrice + cart.sum * cart.sku.servicePrice;
                        if (cart.pointsDeductionInput) {
                            originalTotalPriceYDK = originalTotalPriceYDK + parseFloat(cart.pointsDeductionInput);
                        }
                    }


                    var sku = { skuId: cart.id, sku: cart, sum: cart.sum };

                    var parameter = cart.sku.parameter > 0 ? cart.sku.parameter : 1;
                    var beishu = (cart.sum / parameter);
                    cart.sku.yearIntegral = ((user.business.businessType === 0 ? cart.sku.serviceYearIntegral : cart.sku.dealerYearIntegral) * beishu).toFixed(2);
                    cart.sku.runIntegral = ((user.business.businessType === 0 ? cart.sku.serviceRunIntegral : cart.sku.dealerRunIntegral) * beishu).toFixed(2);

                    buyItems.skus.push(sku);
                }
                setSelectedAll(selectedAll && cart.selected);
                return cart.selected;
            });
            setSelectedItems(theSelectedItems);
            buyItems.point = totlepoint;
            buyItems.price = totleprice;
            //storage.set('buy-items', JSON.stringify(buyItems));
            setTotleprice( buyItems.price.toFixed(2));
            //setTotlepriceTz( Math.round((totleprice * 0.03) * 100) / 100);
            setTotlepoint( buyItems.point.toFixed(2));
            //setTotalPriceOriginal(Math.round(originalTotalPrice * 10000) / 10000);
            //setTotalPriceOriginalDK ( Math.round(originalTotalPrice * 0.02 * 10000) / 10000);
            //setTotalPriceOriginalYDK (Math.round(originalTotalPriceYDK * 10000) / 10000);
        }
    }
    const reCalSum =(sku, sum)=> {
        var minOrderQuantity = 1;
        var orderMultiple = 1;
        if (sku && sku.minOrderQuantity && sku.orderMultiple) {
            minOrderQuantity = sku.minOrderQuantity;
            orderMultiple = sku.orderMultiple;
        }
        sum = parseInt(sum) <= minOrderQuantity ? minOrderQuantity : parseInt(sum);
        if (sum % orderMultiple != 0) {
            sum = sum - sum % orderMultiple + orderMultiple;
        }
        return sum;
    }
    const loadData = () => {
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            return;
            //history.goBack();
        }
        var departmentId;
        if (user && user.canBuyDepartmentIds && user.canBuyDepartmentIds.length > 0) {
            if (localStorage.getItem("currentDId") && localStorage.getItem("currentDId") !="null") {
                setCurrentDId(localStorage.getItem("currentDId"));
                departmentId = localStorage.getItem("currentDId");
                localStorage.setItem("currentDId", null);
            }
            else {
                setCurrentDId(user.canBuyDepartmentIds[0].id); //23,24,25
                departmentId = user.canBuyDepartmentIds[0].id;
            }
        }
        setShowLoading(true);
        get('delianapi/business/my').then((response) => {
            if (response.statusCode !== 200 || response.items.length == 0) {
                return;
            }
            setItem(response.items[0]);

            getCart().then(function (response) {
                setShowLoading(false);
                if (response.statusCode !== 200) {
                    setIsShowLogin(true);
                    return;
                }
                var items = response.items;
                items.forEach(function (cart) {
                    cart.selected = true;
                });
                var list = items.filter(function (c) { return c.sku; });
                list.forEach(function (cart) {
                    cart.sku.oldServicePrice = cart.sku.servicePrice;
                    if (cart.sku.isCanPoints) {
                        cart.pointsDeduction = cart.sku.servicePrice * cart.sum;
                    } else {
                        cart.pointsDeduction = 0;
                    }
                    if (cart.sku.imageUrl) {
                        cart.sku.imageUrl = cart.sku.imageUrl + '.small.png';
                    }
                    else {
                        cart.sku.imageUrl = dataFoot.noimageSmall;
                    }
                });
                setCartlist(list);
                clickDepartment(departmentId, list);
                //setTimeout(function () {
                //    if ($(window).height() >= $(".cartlist").height() + 300) {
                //        $('.heji').removeClass('fixed');
                //    }
                //    else {
                //        $('.heji').addClass('fixed');
                //    }
                //}, 0);
            });

        });
    }

    const updateCart = (cart,index) => {
        const newCartList = [...cartlist];
        newCartList[index] = cart;
        setCartlist(newCartList); 

        var theCartlistsub = [...cartlistsub];
        theCartlistsub[index] = cart;
        setCartlistsub(theCartlistsub);


    }
    const handleQuantityChange = (event, cart,index) => {
        // 使用replace方法移除非数字字符  
        const newValue = event.target.value.replace(/[^\d]/g, '');
        cart.sum = newValue;
        updateCart(cart, index);
    };
    const handleQuantityPaste = (event) => {
        // 阻止默认粘贴行为  
        event.preventDefault();
    };
    const validateNum = (cart,index) =>{
        if (cart.sku.minOrderQuantity > 0) {
            if (cart.sum < cart.sku.minOrderQuantity) {
                cart.sum = cart.sku.minOrderQuantity;
            }
            else {
                if (cart.sku.orderMultiple > 0 && cart.sum % cart.sku.orderMultiple != 0) {
                    var n = parseInt(cart.sum / cart.sku.orderMultiple);
                    cart.sum = cart.sku.orderMultiple * n;
                }
            }
        }
        updateCart(cart, index);

    }
    const minusQuantity = (cart, index) =>{
        if (isNaN(cart.sum)) {
            cart.sum = minOrderQuantity;
        }
        var minOrderQuantity = 1;
        var orderMultiple = 1;
        if (cart.sku && cart.sku.minOrderQuantity && cart.sku.orderMultiple) {
            minOrderQuantity = cart.sku.minOrderQuantity;
            orderMultiple = cart.sku.orderMultiple;
        }
        cart.sum = parseInt(cart.sum) <= minOrderQuantity ? minOrderQuantity : parseInt(cart.sum) - orderMultiple;
        cart.sum = reCalSum(cart.sku, cart.sum);
        cart.pointsDeduction = cart.sum * cart.sku.servicePrice;
        saveCart(cart.skuId, cart.sum);
        updateCart(cart, index);

    };
    const addQuantity = (cart, index)=> {
        if (isNaN(cart.sum)) {
            cart.sum = 1;
        }
        cart.sum = parseInt(cart.sum) + 1;
        cart.sum = reCalSum(cart.sku, cart.sum);
        cart.pointsDeduction = cart.sum * cart.sku.servicePrice;
        saveCart(cart.skuId, cart.sum);
        updateCart(cart, index);

    };
    const selectedAllClick = (value) => {
        setSelectedAll(value);
        var theCartlistsub = [...cartlistsub];
        theCartlistsub.forEach(function (cart) {
            cart.selected = value;
        });
        setCartlistsub(theCartlistsub);
    }
    const clickDepartment = (dId, newList) => {
        var list = newList ?? cartlist;
        if (dId > 0) {
            setCurrentDId(dId);
            setCartlistsub(list.filter(function (c) {
                return c.sku.departmentId == dId;
            }));
        }
        else if (currentDId>0) {
            setCartlistsub(list.filter(function (c) {
                return c.sku.departmentId == currentDId;
            }));
        }
    }
    const deleteCart = (cart) => {        
        setCurrentItem(cart);
        setConfirmDialog(true);
    }
    const confirmDeleteFinish = (cart) => {
        var theCartlistsub = [...cartlistsub];
        var theCartlist = [...cartlist];

        if (cart) {
            saveCart( cart.skuId, 0);
            var index = theCartlist.indexOf(cart);
            theCartlist.splice(index, 1);
            setCartlist(theCartlist);
           
            index = theCartlistsub.indexOf(cart);
            theCartlistsub.splice(index, 1);
            setCartlistsub(theCartlistsub);
        }
        else {            
            selectedItems.forEach(function (cart) {
                saveCart(cart.skuId, 0);
                var index = theCartlist.indexOf(cart);
                theCartlist.splice(index, 1);
                setCartlist(theCartlist);

                index = theCartlistsub.indexOf(cart);
                theCartlistsub.splice(index, 1);
            });
            setCartlistsub(theCartlistsub);
        }
        setConfirmDialog(false);
    }

    const confirmOrder = ()=> {
        if (selectedItems.length == 0) {
            setErrorMessage("请选择至少一件商品结算！");
            return;
        }

        if (user.business.parentBusinessList[0].id == -999) {
            var basfitems = selectedItems.filter(function (item) {
                return item.sku != null && (item.sku.code == "1.03.004.000002" || item.sku.code == "1.03.004.000003"
                    || item.sku.code == "1.03.004.000004" || item.sku.code == "1.05.045.000003"
                    || item.sku.code == "1.05.045.000004" || item.sku.code == "1.05.045.000017"
                    || item.sku.code == "1.05.045.000005" || item.sku.code == "1.05.045.000006"
                    || item.sku.code == "1.05.045.000012" || item.sku.code == "1.05.045.000013"
                    || item.sku.code == "1.05.045.000018" || item.sku.code == "1.05.045.000014"
                    || item.sku.code == "1.05.045.000015" || item.sku.code == "8.05.001.000009")
            });

            var basfCount = basfitems.length;
            var allCount = selectedItems.length;
            var isAllBasfProduct = (basfCount > 0 && basfCount == allCount);
            if (basfCount > 0 && !isAllBasfProduct) {
                setErrorMessage("单笔订单巴斯夫产品和德联产品不能混合购买，请分开下单！");
                return;
            }
            if (isAllBasfProduct && totleprice < 20000) {
                setErrorMessage("单笔巴斯夫产品订单金额不能低于2万元！");
                return;
            }
            else if (!isAllBasfProduct && totleprice < 30000) {
                setErrorMessage("单笔订单金额不能低于3万元！");
                return;
            }

        }
        if (totlepoint > 0) {
            var points = parseFloat(item.allPoints);
            if (points >= 0) {
                if ((points + item.creditScorePoints) < totlepoint) {
                    setErrorMessage('你有积分' + points + '，可透支授信积分' +
                        item.creditScorePoints + '，当前订单需要使用积分' +
                        totlepoint + '，积分不够，请修改订单！');
                    return;
                }
            } else {
                if ((item.creditScorePoints) < totlepoint) {
                    setErrorMessage('你有积分' + points + '，可透支授信积分' +
                        item.creditScorePoints + '，当前订单需要使用积分' +
                        totlepoint + '，积分不够，请修改订单！');
                    return;
                }
            }

        }
        localStorage.setItem('selectedItems', JSON.stringify(selectedItems));
        navigate(config.root + '/confirmorder');
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    const handCheckChange = (cart,value) => {
        cart.selected = value;
        updateCart(cart);
    }
    const handleLocalImageError = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState, type, productId);
    };
    const setErrorState = (productId, defaultImageUrl) => {
        const oldlist = [...cartlistsub];
        oldlist.forEach(function (item) {
            if (item.skuId == productId) {
                item.sku.imageUrl = defaultImageUrl;
                item.error = true;
            }
        });
        setCartlistsub(oldlist);
    };
    return (      
        <div className="cartlist " >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="title">
                    <span className="cartTitle">购物车</span>                    
                    <div className="cart-quantity">
                        全部商品 <span className="red" >{cartlistsub.length} </span> 件
                        {
                            item &&
                            <span className="points">可用积分：
                                <span className="red" >{item.allPoints ? item.allPoints : '0'}</span>
                            </span>
                        }
                        {
                            item &&
                            <span className="points" >授信积分：
                                <span className="red" >{item.creditScorePoints ? item.creditScorePoints : '0'}</span>
                            </span>
                        }
                    </div>
                    {
                        user && user.canBuyDepartmentIds && user.canBuyDepartmentIds.length > 0 &&
                        (<div className="logoList">
                            {
                                user.canBuyDepartmentIds.map((item, index) => (
                                    <div key={item.id}
                                        className={`logo logo${index} ${currentDId == item.id ? "current" : ""}`}
                                        onClick={() => clickDepartment(item.id)}>
                                        <span className="mobile-show">{item.name}</span>
                                    </div>
                                )
                                )
                            }
                        </div>)
                    }
                </div>
                <div className="cartlistDiv" >
                    <div className="thead" >
                        <div ></div>
                        <div >商品</div>
                        <div >规格</div>
                        <div >单价（元）</div>
                        <div >数量</div>
                        <div >小计</div>
                        <div ></div>
                    </div>
                       {
                        cartlistsub.map((cart, index) => (                                
                                    screenSize > 991 ? (
                                    <div className="tr" key={`cart-${cart.skuId}`}>
                                        <div>
                                            <CheckBox value={cart.selected} name={`check-${cart.skuId}`}
                                                onChange={(value) => handCheckChange(cart, value)} />
                                            <img className="cart-image" onError={() => handleLocalImageError(cart, 'small')}
                                                src={cart.sku.imageUrl} alt=" " />
                                        </div>
                                        <div>
                                            <Link to={config.root + '/productdetail/' + cart.sku.productId}>
                                                <span >{cart.sku.productName}</span>
                                            </Link>

                                        </div>
                                        <div>
                                            <span >{cart.sku.skuName.split('|').join(' ')}</span>
                                        </div>
                                        <div>
                                            <span className={cart.sku.isCanPoints ? 'blue' : 'red'}>
                                                <small >{cart.sku.isCanPoints ? '积分' : '￥'}</small>
                                                <span className="fs-14" >{cart.sku.servicePrice}</span>
                                            </span>
                                        </div>
                                        <div>
                                            <div className="quantityOperate">
                                                <a className="operate minus" onClick={() => minusQuantity(cart, index)}>-</a>
                                                <input value={cart.sum} onChange={(event) => handleQuantityChange(event, cart, index)}
                                                    onBlur={() => { validateNum(cart, index) }}
                                                    onPaste={handleQuantityPaste} />
                                                <a className="operate add" onClick={() => addQuantity(cart, index)}>+</a>
                                            </div>
                                            {
                                                cart.sku.minOrderQuantity &&
                                                <div className="cart-info" >
                                                    <span>起订量/幅度：{cart.sku.minOrderQuantity} /{cart.sku.orderMultiple}</span>
                                                </div>
                                            }

                                        </div>
                                        <div>
                                            {
                                                !cart.sku.isCanPoints &&
                                                <div className="red" >
                                                    <small>￥</small>
                                                    <span className="fs-14" >{(cart.sku.servicePrice * cart.sum).toFixed(2)}</span>
                                                </div>
                                            }
                                            {
                                                cart.sku.isCanPoints &&
                                                <div className="blue" >
                                                    <small>积分</small>
                                                    <span className="fs-14" >{(cart.pointsDeduction).toFixed(2)}</span>
                                                </div>
                                            }

                                        </div>
                                        <div>
                                            <div className="delete-icon" onClick={() => deleteCart(cart)}></div>
                                        </div>
                                    </div>):
                                (
                                    <div className="tr" key={`cart-${cart.skuId}`}>
                                        <div>
                                            <CheckBox value={cart.selected} name={`check-${cart.skuId}`}
                                                onChange={(value) => handCheckChange(cart, value)} />
                                            <img className="cart-image" onError={() => handleLocalImageError(cart, 'small')}
                                                src={cart.sku.imageUrl} alt=" " />
                                        </div>
                                        <div>
                                            <div>
                                                <Link to={config.root + '/productdetail/' + cart.sku.productId}>
                                                    <span >{cart.sku.productName}</span>
                                                    <span >( {cart.sku.skuName.split('|').join(' ')} )</span>
                                                </Link>
                                            </div>
                                            <div className="flex-end">
                                                <div className="quantityOperate">
                                                    <a className="operate minus" onClick={() => minusQuantity(cart, index)}>-</a>
                                                    <input value={cart.sum} onChange={(event) => handleQuantityChange(event, cart, index)}
                                                        onBlur={() => { validateNum(cart, index) }}
                                                        onPaste={handleQuantityPaste} />
                                                    <a className="operate add" onClick={() => addQuantity(cart, index)}>+</a>
                                                </div>
                                            </div>
                                            <div className="flex-between">
                                                {
                                                    !cart.sku.isCanPoints &&
                                                    <div className="red" >
                                                        <small>￥</small>
                                                        <span className="fs-14" >{(cart.sku.servicePrice * cart.sum).toFixed(2)}</span>
                                                    </div>
                                                }
                                                {
                                                    cart.sku.isCanPoints &&
                                                    <div className="blue" >
                                                        <small>积分</small>
                                                        <span className="fs-14" >{(cart.pointsDeduction).toFixed(2)}</span>
                                                    </div>
                                                }
                                                {
                                                    cart.sku.minOrderQuantity &&
                                                    <div className="cart-info" >
                                                        <span>起订量/幅度：{cart.sku.minOrderQuantity} /{cart.sku.orderMultiple}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>)  
                            ))
                        }
                </div>
               
            </div>
            <div className="heji">
                <div className="content">
                    <div className="left-content">
                <CheckBox value={selectedAll} name={`check-all`}
                    onChange={selectedAllClick} title="全选"/>
                {
                    selectedItems.length > 0 &&
                    <button className="deleteCart" onClick={()=>deleteCart(null)}>删除选中商品</button>
                }               
                     </div>
                    <div className="right-content" >
                        <div className="flex-between"><div >
                            已选商品 <span className="red" >{selectedItems.length}</span> 件   </div>
                            <div >
                               合计：                         
                                <span className="red ">￥<span className="fs-32 totleprice" >{totleprice}</span></span>
                        {
                            totlepoint > 0 &&
                            <span className="blue" > + 积分
                                <span className="fs-32 totleprice" >{totlepoint}</span></span>
                                }
                            </div>
                        </div>
                        <Button onClick={confirmOrder}
                            btnclass={`btn  jiesuan fs-25 ${selectedItems.length == 0 ? 'disabled' : ''}`}
                            disabled={selectedItems.length == 0} title="结算" />

                    </div>
                </div>
             </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={ errorMessage} onCancel={() => {
                setErrorMessage("");
            }} />            
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <ConfirmDialog isShowConfirmDialog={isShowConfirmDialog}
                message="确定要删除吗？"
                data={currentItem}
                onConfirm={confirmDeleteFinish}
                onCancel={() => { setConfirmDialog(false) }}
            />
        </div>
          
    );
}

export default Cartlist;